<script setup lang="ts">
import type { CardBasic } from '@/types/pvp-card';
import { equipQualityText } from '@/views/item/data';
import { computed } from 'vue';
import { SpecialFormulas } from '../services/enum';

const props = defineProps<{
    card: CardBasic,
    upgradeable: boolean
}>()
function getCardType(type: string) {
    switch (type) {
        case 'flying': return '飞行';
        case 'ground': return '地面';
        case 'building': return '建筑';
        case 'ghost': return '灵体';
    }
}
const damage = computed(() => {
    const damage = props.card.damage
    return Math.round(
        damage * Math.pow(1 + props.card.damageGrow, props.card.level - 1)
    );
})
const health = computed(() => {
    const health = props.card.health
    return Math.round(
        health * Math.pow(1 + props.card.healthGrow, props.card.level - 1)
    );
})

const specials = computed(() => {
    return props.card.specials.map((special) => {
        const [name, params] = special
        return SpecialFormulas[name]?.call(props.card, params) ?? '存在未实现的效果'
    })
})
function getArkType(card: any) {
    return card.targetType.map((type: any) => getCardType(type)).join('/')
}

</script>
<template>
    <div>
        <h3>{{ card.name }}</h3>
        <h4 :class="card.grade">lv{{ card.level }}</h4>
        <div :class="card.grade">
            <!-- 标签按钮 -->
            <div style="display: flex; justify-content: center; gap: 10px; margin: 10px;">
                <button class="tab-button">
                    <div>品级</div>
                    <div class="tab-label">{{ equipQualityText[card.grade] }}</div>
                </button>
                <button class="tab-button">
                    <div>类型</div>
                    <div class="tab-label">{{ getCardType(card.type) }}</div>
                </button>
                <button class="tab-button">
                    <div>数量</div>
                    <div class="tab-label">{{ card.num }}</div>
                </button>
            </div>
            <!-- 属性面板 -->
            <div class="stats-panel">
                <div class="stat-item">
                    <div class="stat-icon">🔥</div>
                    <div>
                        <div class="stat-label">伤害</div>
                        <div class="stat-value affix">{{ damage }}
                            <span v-show="upgradeable" class="grow">+{{ Math.round(damage * card.damageGrow) }}</span>
                        </div>
                    </div>
                </div>
                <div class="stat-item">
                    <div class="stat-icon">❤️</div>
                    <div>
                        <div class="stat-label">生命值</div>
                        <div class="stat-value affix">{{ health }}
                            <span v-show="upgradeable" class="grow">+{{ Math.round(health * card.healthGrow) }}</span>
                        </div>
                    </div>
                </div>

                <div class="stat-item">
                    <div class="stat-icon">⚔️</div>
                    <div>
                        <div class="stat-label">攻击速度</div>
                        <div class="stat-value">{{ card.attackSpeed ? +(1 / card.attackSpeed).toFixed(2) + '秒' : '无' }}
                        </div>
                    </div>
                </div>
                <div class="stat-item">
                    <div class="stat-icon">🎯</div>
                    <div>
                        <div class="stat-label">目标</div>
                        <div class="stat-value">{{ getArkType(card) || '无' }}</div>
                    </div>
                </div>

                <div class="stat-item">
                    <div class="stat-icon">🕊️</div>
                    <div>
                        <div class="stat-label">移动速度</div>
                        <div class="stat-value">{{ card.moveSpeed ? +(1 / card.moveSpeed).toFixed(2) + '秒' : '无' }}
                        </div>
                    </div>
                </div>
                <div class="stat-item">
                    <div class="stat-icon">🏹</div>
                    <div>
                        <div class="stat-label">射程</div>
                        <div class="stat-value">{{ card.attackRange }}格</div>
                    </div>
                </div>
                <div class="stat-item skill affix" v-if="specials.length">
                    <div v-for="special in specials" v-html="special"></div>
                </div>
            </div>
        </div>
    </div>

</template>
<style lang="scss" scoped>
/* 标签按钮 */
.tab-button {
    background-color: currentColor;
    color: inherit;
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;

    &>div:first-of-type {
        color: white;
    }
}



.tab-label {
    background-color: #00000070;
    color: white;
    padding: 4px 8px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
}


/* 属性面板 */
.stats-panel {
    background-color: #dcdde0;
    border-radius: 4px;
    padding: 8px;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.1);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
}

.stat-item {
    display: flex;
    padding: 8px;
    background-color: #e8e8ea;
    border-radius: 4px;
    font-size: 12px;
    align-items: center;

    &.skill {
        grid-column: span 2;
        color: #333;
        font-size: 14px;
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
    }
}



.stat-icon {
    width: 30px;
    height: 30px;
    background-color: #1a2d5e;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    margin-right: 10px;
}

.stat-value {
    font-weight: bold;
    font-size: 14px;
    color: black;
}

.stat-label {
    color: #333;
}
</style>